import { type Theme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';
import { type MouseEventHandler } from 'react';
import { MovieDetailsHeader } from '#components/Details/DetailsHeader/MovieDetailsHeader.tsx';
import { TvDetailsHeader } from '#components/Details/DetailsHeader/TvDetailsHeader.tsx';
import { isMovieData, isTvData } from '#helpers/dataTypeGuards.ts';
import { type ComponentProps } from '../types.ts';
import { DetailsHeaderSkeleton } from './DetailsHeaderSkeleton.tsx';

export type DetailsHeaderProps = ComponentProps & {
  compact?: boolean;
  linkTitle?: boolean;
  showExpandIcon?: boolean;
  sx?: SystemStyleObject<Theme>;
  titleLinkOnClick?: MouseEventHandler<HTMLAnchorElement>;
};

export const DetailsHeader = ({ compact, data, ...rest }: DetailsHeaderProps) => {
  if (!data) {
    return <DetailsHeaderSkeleton compact={compact} />;
  }

  if (isMovieData(data)) {
    return <MovieDetailsHeader compact={compact} data={data.movie} {...rest} />;
  }

  if (isTvData(data)) {
    return <TvDetailsHeader compact={compact} data={data.tv} {...rest} />;
  }

  return;
};
